import { Injectable } from '@angular/core'
import { HttpService } from '@lla-platform/core/core-data-access'
import { SCHEDULER_API_URL } from './scheduler-api-routes'
import { Observable } from 'rxjs'
import {
  IAllLocationSchedulesResponse,
  IApproveLocationScheduleRequest,
  ILocationScheduleResponse,
  IRejectLocationScheduleRequest,
  ISchedulerSummary,
  ISetLocationScheduleRequest,
  ISetLocationScheduleResponse
} from '../interfaces/scheduler.interface'
import { ISchedulerEmployeeResponse } from '../interfaces/scheduler-employee.interface'
import { IScheduleTemplatePayload } from '../interfaces/schedule-template.interface'
import {
  IScheduleAttendanceRequest,
  IScheduleAttendanceResponse
} from '../interfaces/schedule-attendance.interface'

@Injectable({
  providedIn: 'root'
})
export class SchedulerService {
  constructor(private http: HttpService) {}

  getLocationSchedule(locationId: string, weekNumber: string): Observable<ILocationScheduleResponse> {
    return this.http.get<ILocationScheduleResponse>(SCHEDULER_API_URL.getLocationSchedule, {
      params: {
        locationId,
        weekNumber
      }
    })
  }

  rejectLocationSchedule(payload: IRejectLocationScheduleRequest): Observable<ISchedulerSummary> {
    return this.http.post<ISchedulerSummary>(SCHEDULER_API_URL.rejectLocationSchedule, payload)
  }

  getEmployeesBookedSchedule(weekNumber: string): Observable<ISchedulerEmployeeResponse> {
    return this.http.get<ISchedulerEmployeeResponse>(SCHEDULER_API_URL.getEmployeesBookedSchedule, {
      params: {
        weekNumber
      }
    })
  }

  setLocationSchedule(payload: ISetLocationScheduleRequest): Observable<ISetLocationScheduleResponse> {
    return this.http.post<ISetLocationScheduleResponse>(SCHEDULER_API_URL.setLocationSchedule, payload)
  }

  approveLocationSchedule(payload: IApproveLocationScheduleRequest): Observable<ISchedulerSummary> {
    return this.http.post<ISchedulerSummary>(SCHEDULER_API_URL.approveLocationSchedule, payload)
  }

  getAllLocationSchedules(weekNumber: string): Observable<IAllLocationSchedulesResponse> {
    return this.http.get<IAllLocationSchedulesResponse>(SCHEDULER_API_URL.getAllLocationSchedules, {
      params: {
        weekNumber
      }
    })
  }

  deleteLocationSchedule(locationScheduleId: string) {
    return this.http.delete(SCHEDULER_API_URL.deleteLocationSchedule(locationScheduleId))
  }

  getScheduleTemplate(locationId: string): Observable<IScheduleTemplatePayload> {
    return this.http.get<IScheduleTemplatePayload>(SCHEDULER_API_URL.scheduleTemplate(locationId))
  }

  setScheduleTemplate(locationId: string, payload: IScheduleTemplatePayload) {
    return this.http.post(SCHEDULER_API_URL.scheduleTemplate(locationId), payload)
  }

  cancelRegionalManagerApproval(locationScheduleId: string) {
    return this.http.post(SCHEDULER_API_URL.cancelRegionalManagerApproval, {
      locationScheduleId
    })
  }

  getScheduleAttendance(payload: IScheduleAttendanceRequest): Observable<IScheduleAttendanceResponse> {
    return this.http.post<IScheduleAttendanceResponse>(SCHEDULER_API_URL.getScheduleAttendance, payload)
  }
}
